var modal = document.querySelector(".custom-modal");
var btn = document.querySelector(".custom-modal-trigger");
var span = document.querySelector(".custom-modal__close");
var unmadeIframeElement = document.querySelector('#iframe-unmade');

btn.onclick = function() {
  // unmadeIframe.src = unmadeIframe.getAttribute('data-src');
  modal.style.display = "block";
}

span.onclick = function() {
  modal.style.display = "none";
}

window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
}

window.onload = function() {
  if(window.location.hash === '#editor') {
    var event = new Event('click');
    btn.dispatchEvent(event);
  }
}


